import { createSlice } from "@reduxjs/toolkit";
import {
  Loading,
  PasswordValidationStatus,
  UserRepository,
  validatePassword,
} from "../domain";
import { ServiceLocater, Services } from "../service-locater";
import { AppThunk } from "./store";

type ChangePasswordState = {
  password: string;
  repeatPassword: string;
  passwordValidationStatus: PasswordValidationStatus | "invalid";
  hasSubmitted: boolean;
  loading: Loading;
};

const initialState: ChangePasswordState = {
  password: "",
  repeatPassword: "",
  passwordValidationStatus: "invalid",
  hasSubmitted: false,
  loading: "idle",
};

const changePasswordSlice = createSlice({
  name: "changePassword",
  initialState,
  reducers: {
    setPasssword(state, { payload }) {
      state.passwordValidationStatus = validatePassword(
        payload,
        state.repeatPassword
      );
      state.password = payload;
    },
    setRepeatPassword(state, { payload }) {
      state.passwordValidationStatus = validatePassword(
        state.password,
        payload
      );
      state.repeatPassword = payload;
    },
    changePasswordSubmitted(state) {
      state.hasSubmitted = true;
    },
    changePasswordLoading(state) {
      state.loading = "pending";
    },
    changePasswordFailure(state) {
      state.loading = "failed";
    },
    changePasswordSuccess(state) {
      state.loading = "succeeded";
    },
  },
});

export const { setPasssword, setRepeatPassword } = changePasswordSlice.actions;
export default changePasswordSlice.reducer;

const {
  changePasswordFailure,
  changePasswordLoading,
  changePasswordSuccess,
  changePasswordSubmitted,
} = changePasswordSlice.actions;

export const changePassword = (
  phone: string,
  token: string
): AppThunk => async (dispatch, getState) => {
  dispatch(changePasswordSubmitted());
  if (getState().changePassword.passwordValidationStatus === "valid") {
    dispatch(changePasswordLoading());
    const res = await ServiceLocater.get<UserRepository>(
      Services.UserRepository
    ).changePassword(phone, getState().changePassword.password, token);
    res.fold(
      (l) => dispatch(changePasswordFailure()),
      (r) => dispatch(changePasswordSuccess())
    );
  }
};
